import { ModelApiService } from './BaseApiService'

export default class ContactApiService extends ModelApiService {
  constructor() {
    super('contact')
  }

  async sendMessage(payload) {
    return await this.post(`${payload.id}/messages`, payload)
  }
}
